import { HoursTypeEnum } from '@modules/filters/enums';

export const hoursTypeLabel = {
  [HoursTypeEnum.WorkingHours]: 'Working Hours',
  [HoursTypeEnum.PeakHours]: 'Peak Hours',
  [HoursTypeEnum.AfterHours]: 'After Hours',
  [HoursTypeEnum.AllDay]: 'All Day',
};
